import { IconTruck } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import {
  DiscountType,
  type ShippingMethods as ShippingMethodsType,
} from 'typings'
import { useFormStateContext } from '../../../../providers'
import { useDrawerState } from '../../../Drawer'
import { messages } from './messages'

import { useEffect } from 'react'
import {
  FormAliasKeys,
  useAddFormAlias,
} from '../../../../providers/useFormAlias.constate'
import { useConditions } from '../useConditions'
import { ShippingMethodsEditor } from './Editor'
import { ShippingMethodsView } from './View'
import { useShippingMethodsRelation } from './hooks/useShippingMethodsRelation'

type ShippingMethodsProps = {
  name: string
}

export function ShippingMethods(props: ShippingMethodsProps) {
  const { name } = props
  const drawerState = useDrawerState()
  const { formatMessage: i18n } = useIntl()
  const { form, discountType } = useFormStateContext()

  const { addAlias } = useAddFormAlias()

  useShippingMethodsRelation({ name })

  useConditions({
    name,
    onEdit: drawerState.show,
    label: i18n(messages.title),
    icon: <IconTruck />,
    hidden: discountType === DiscountType.Shipping,
  })

  useEffect(() => {
    addAlias({
      value: name,
      key: FormAliasKeys.shippingMethods,
    })
  }, [addAlias, name])

  const shippingMethods: ShippingMethodsType | undefined = useWatch({
    form,
    name,
  })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (config: ShippingMethodsType) => {
    form.setValue(name, config.length ? config : undefined)
  }

  return (
    <>
      <ShippingMethodsView
        values={shippingMethods}
        onEdit={drawerState.show}
        onRemove={handleRemove}
      />
      <ShippingMethodsEditor
        state={drawerState}
        config={shippingMethods}
        onSave={handleSave}
      />
    </>
  )
}
